// Properties Data Table Configuration - matching admin-web structure
import React from 'react';
import { Text, View } from 'react-native';
import { IColumnConfig } from '@/types/admin/dataTable';
import { IPropertyRowData } from '@/types/admin/properties';
import { ADMIN_COLORS } from '@/constants/admin';

export const PROPERTY_TABLE_COLUMNS: IColumnConfig<IPropertyRowData>[] = [
  {
    key: 'marketingName',
    label: 'NAME',
    width: 200,
    sortable: true,
    sortType: 'string',
    filterable: true,
    filterType: 'text',
    visible: true,
    renderCell: (value: string, row: IPropertyRowData) => (
      <View>
        <Text style={{ fontWeight: '700', fontSize: 14, color: ADMIN_COLORS.TEXT.PRIMARY }}>{value}</Text>
      </View>
    ),
  },
  {
    key: 'externalId',
    label: 'EXTERNAL ID',
    width: 150,
    sortable: true,
    sortType: 'string',
    filterable: true,
    filterType: 'text',
    visible: true,
    renderCell: (value: number, row: IPropertyRowData) => (
      <View>
        <Text style={{ fontSize: 14, color: ADMIN_COLORS.TEXT.PRIMARY }}>{value}</Text>
      </View>
    ),
  },
  {
    key: 'address',
    label: 'ADDRESS',
    width: 250,
    sortable: true,
    sortType: 'string',
    filterable: true,
    filterType: 'text',
    visible: true,
    renderCell: (value: string, row: IPropertyRowData) => (
      <View>
        <Text style={{ fontSize: 14, color: ADMIN_COLORS.TEXT.PRIMARY }}>{value || 'N/A'}</Text>
      </View>
    ),
  },
];

